import { render, staticRenderFns } from "./CustomersReport.vue?vue&type=template&id=43eda21a&"
import script from "./CustomersReport.vue?vue&type=script&lang=js&"
export * from "./CustomersReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports